export class EdgeResizer {
  constructor(fileUrl) {
    if (!fileUrl) {
      throw new Error('Missing file url in EdgeResizer');
    }

    const url = new URL(fileUrl);
    this.fileUrl = url.origin + url.pathname;
    this.params = new URLSearchParams(url.search);
    this.composites = [];

    // Clean existing params
    for (const [key, value] of this.params.entries()) {
      if (!value) {
        this.params.delete(key);
      }
    }
  }

  _isImageProcessable() {
    if (this.fileUrl.endsWith('.svg')) {
      return false;
    }

    return true;
  }

  _getBaseUrl() {
    return process.env.EDGE_RESIZER;
  }

  _getFileKey() {
    return this.fileUrl.split('/').pop();
  }

  _getUrl() {
    const baseUrl = this._getBaseUrl();
    const key = this._getFileKey();
    return `${baseUrl}/images/${key}?${this.params.toString()}`;
  }

  scaleToWidth(newWidthValue) {
    if (!this._isImageProcessable()) {
      return this.fileUrl;
    }

    this.params.set('w', newWidthValue);
    return this._getUrl();
  }

  scaleToHeight(newHeightValue) {
    if (!this._isImageProcessable()) {
      return this.fileUrl;
    }

    this.params.set('h', newHeightValue);
    return this._getUrl();
  }

  resize(newWidthValue, newHeightValue, resizeType = 'cover') {
    if (!this._isImageProcessable()) {
      return this.fileUrl;
    }

    this.params.set('w', newWidthValue);
    this.params.set('h', newHeightValue);
    this.params.set('t', resizeType);
    return this._getUrl();
  }

  blur(value) {
    if (!this._isImageProcessable()) {
      return this.fileUrl;
    }

    this.params.set('blur', value);
    return this._getUrl();
  }

  composite(url, blendMode) {
    if (!this._isImageProcessable()) {
      return this;
    }

    this.composites.push({
      url,
      blend: blendMode,
    });

    const compositeParam = btoa(JSON.stringify(this.composites));

    this.params.set('composite', compositeParam);

    return this._getUrl();
  }
}
